import { FAQs as BaseFAQs } from "../components/faqs.tsx";

const valuationsFAQs = [
  {
    question: "What is included in my free property valuation?",
    answer:
      "Your free property valuation includes a comprehensive in-person assessment of your property's current market value based on recent comparable sales, local market conditions, and property-specific features by a specialist solicitor estate agent. You'll receive a detailed valuation report and expert advice from a local ESPC solicitor estate agent.",
  },
  {
    question: "How long does it take to receive my property valuation?",
    answer:
      "After submitting your details, an ESPC solicitor estate agent will contact you to arrange your valuation. They will then arrange a time that’s convenient to you to provide an in-person visit to your property to provide an accurate and insightful property valuation.",
  },
  {
    question: "Do I need to prepare my property before valuation?",
    answer:
      "Before a solicitor estate agent visits your property, we recommend a basic tidy-up to help them see the property clearly, but they don't expect show-home conditions. They are experienced at seeing past day-to-day living.",
  },
  {
    question: "What factors affect my property's valuation?",
    answer:
      "Key factors include location, property size and condition, number of bedrooms and bathrooms, unique features, recent home improvements, local market conditions, comparable recent sales, and current demand in your area.",
  },
  {
    question: "Is there any obligation to sell with the ESPC solicitor estate agent after receiving a valuation?",
    answer:
      "Absolutely not. Our solicitor estate agent valuation service is completely free and without obligation. While they’d be delighted to help you sell your property, the decision to proceed with one of our associated solicitor agents remains entirely yours.",
  },
  {
    question: "How accurate are your property valuations?",
    answer:
      "ESPC solicitor estate agent valuations are known for their accuracy as they're based on our extensive database of actual sales in your area, a complete review of the current market conditions, and our solicitor estate agents' local expertise. This combination allows them to provide valuations that closely reflect achievable selling prices.\n\n" +
      "In-person valuations are far more accurate than online valuations, as they take into account all of the unique characteristics of your property, offering a true reflection of market value rather than a best guess.",
  },
  {
    question: "Can you value properties throughout Scotland?",
    answer:
      "The ESPC network of local solicitor estate agent property experts covers Edinburgh, the Lothians, Fife, the Borders, Dumfries & Galloway and the west of Scotland.",
  },
  {
    question: "What information do I need to provide for a valuation?",
    answer:
      "To get started, we need your basic contact details, property address, number of bedrooms, and property type. Your chosen solicitor estate agents will then get in touch to gather more information.",
  },
  {
    question: "Can I get a valuation if I'm not planning to sell immediately?",
    answer:
      "Yes, we understand that moving home is a big decision and you need to gather all the relevant information as early as possible. There’s no time limit on when you might choose to do so but the valuation will be based on the current market and that might change over time.",
  },
];

export const FAQs: React.FC = () => <BaseFAQs faqList={valuationsFAQs} />;
